import React from "react";
import styles from "./styles.css";
import ComprehensiveServiceCheckCard from "../comprehensive-service-check-card";
import Forward from "./images/forward.svg";
import PropTypes from "prop-types";

const ComprehensiveServiceCheck = ({ onModalOpen, benefits = {} }) => {
    const { title = "", items = [] } = benefits || {};

    if (items.length === 0) return null;

    return (
        <div styleName={"styles.wrapper"}>
            <div styleName={"styles.topSticker"}>
                <p styleName={"styles.heading"}>{title}</p>
            </div>
            <div styleName={"styles.cardContainer"}>
                {items.map((item) => (
                    <ComprehensiveServiceCheckCard key={item.iconUrl} icon={item.iconUrl} text={item.info} />
                ))}
            </div>
            <div styleName={"styles.knowMoreWrap"} onClick={onModalOpen}>
                <p styleName={"styles.knowMore"}>More about CARS24 servicing</p>
                <img src={Forward} />
            </div>
        </div>
    );
};

ComprehensiveServiceCheck.propTypes = {
    onModalOpen: PropTypes.func,
    benefits: PropTypes.object
};

export default ComprehensiveServiceCheck;
